import React, { useEffect, useRef, useState } from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';
import { CheckCircle2 } from 'lucide-react';

const WhyChooseUs = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="why-us" className="section-padding why-section" ref={sectionRef}>
      <div className="why-background-pattern"></div>
      
      <div className="container">
        <div className={`section-header ${isVisible ? 'fade-in-up' : ''}`}>
          <h2 className="section-title">{strings.whyChooseUs.title}</h2>
        </div>
        
        <div className="reasons-list">
          {strings.whyChooseUs.reasons.map((reason, index) => (
            <div 
              key={index} 
              className={`reason-item ${isVisible ? 'slide-in-right' : ''}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CheckCircle2 size={28} style={{ color: colors.accent }} strokeWidth={2.5} />
              <span>{reason}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
